import { tidClient } from "./client";

export async function signInWithRedirect(_args?: { returnTo?: string }): Promise<void> {
  // returnTo is passed via TIDProvider's appState mechanism when called from
  // React (useAuth().loginWithRedirect({ appState: { returnTo } })). Non-React
  // callers of this method do not currently carry a returnTo across the redirect.
  await tidClient?.loginWithRedirect();
}
